module.exports = __webpack_public_path__ + "img/greenlifetop.c297b208.svg";